import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=none, obj=authed
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("sos_admin_token");
    if (!token) { setAdmin(false); setReady(true); return; }
    api.get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => { localStorage.removeItem("sos_admin_token"); setAdmin(false); })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sos_admin_token", data.token);
    setAdmin({ email: data.email, role: data.role });
  };
  const logout = () => {
    localStorage.removeItem("sos_admin_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
